import React, { useState } from 'react';
import { Button } from '@amzn/awsui-components-core';

import { FeedbackRating } from './FeedbackTypes';

const votedThumbUpSvgPath = '/images/thumb-up-voted.svg';
const unvotedThumbUpSvgPath = '/images/thumb-up.svg';

interface ThumbUpButtonProps {
  hasRated: boolean;
  resourceId: string;
  handleVote: (resourceId: string, rating: FeedbackRating) => Promise<void>;
}

const ThumbUpButton = ({ resourceId, hasRated, handleVote }: ThumbUpButtonProps) => {
  const [isVoting, setIsVoting] = useState<boolean>(false);
  const svgPath = hasRated ? votedThumbUpSvgPath : unvotedThumbUpSvgPath;

  const handleVotingClick = async () => {
    if (!isVoting) {
      const rating = hasRated ? FeedbackRating.Dislike : FeedbackRating.Like;
      setIsVoting(true);
      await handleVote(resourceId, rating);
      setIsVoting(false);
    }
  };

  return (
    <Button
      variant="icon"
      disabled={isVoting}
      iconUrl={svgPath}
      iconAlt="Like button"
      ariaLabel="Like button"
      onClick={handleVotingClick}
    />
  );
};

export default ThumbUpButton;
